import styled from "styled-components";
import Image from "next/image";
import logo from "../../../public/images/logo-fotop.png";

const FooterContainer = styled.footer`
    text-align: center;
    color: #fff;
    background: #2D2D2D;
    padding: 30px;
    margin-top: 40px;

    a {
        color: #fff;
    }

    img {
        margin-bottom: 50px;
    }

    p {
        margin-bottom: 1rem;
    }
`;

const Footer = () => {
    return (
        <FooterContainer>
            <Image src={logo} alt="Fotop" />
            {/* <img src="/images/logo-fotop.png" alt="Fotop" /> */}

            <p><small>O FOTOP não divulga, transfere ou, de qualquer forma, fornece seus dados para terceiros.</small></p>
            <p><small>Para nós, sua privacidade é fundamental. <a href="https://painel.fotop.io/privacidade.html" target="_blank" rel="nofollow noopener noreferrer">Ler política de privacidade</a>.</small></p>
            <p><small>&copy;2021 Fotop | (11) 3868-2333 | sac@fotop.com.br | CNPJ 07.936.428/0001-90 | Rua Ricardo Severo, 73 - São Paulo - SP</small></p>
        </FooterContainer>
    );
};

export default Footer;
